import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/main.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './Services/Redux/store'
import { Provider } from 'react-redux'
import "bootstrap/dist/css/bootstrap.min.css";
import MsaApp from './MsaApp';
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {
        process.env.REACT_APP_NODE_ENV === 'QA' ? (
          <MsaApp />
        ) : (
          <App />
        )
      }
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
